<div class="bb-venue-strip" role="list" [attr.data-density]="density()">
  @for (venue of venues(); track venue.name) {
    <div class="bb-venue-strip__row" role="listitem" [attr.data-state]="venue.state">
      <span class="bb-venue-strip__dot" [class]="stateClass(venue.state)" aria-hidden="true"></span>
      <span class="bb-venue-strip__name">{{ venue.name }}</span>
      <span class="bb-venue-strip__state">{{ stateLabel(venue.state) }}</span>
      <span class="bb-venue-strip__latency">{{ formatLatency(venue.latencyMs) }}</span>
      <span class="bb-venue-strip__throughput">{{ formatThroughput(venue.throughput) }}</span>
      @if (venue.reason) {
        <span class="bb-venue-strip__reason">{{ venue.reason }}</span>
      } @else if (venue.lastSeenAt && venue.state !== 'online') {
        <span class="bb-venue-strip__reason">last seq {{ venue.lastSeenAt }}</span>
      }
    </div>
  }
</div>
